import { render, staticRenderFns } from "./PositionValidityBadge.vue?vue&type=template&id=7362923a&scoped=true"
import script from "./PositionValidityBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionValidityBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PositionValidityBadge.vue?vue&type=style&index=0&id=7362923a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7362923a",
  null
  
)

export default component.exports